import React from 'react';
import { bool, element, func, number } from 'prop-types';
import styled from 'styled-components';

import { Menu, Sidebar } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import logoSVG from '~/images/logo.svg';


const StyledMenu = styled(Menu)`
    && {
        display: flex !important;
        flex-direction: column;
        max-height: calc(100vh - ${p => p.navbarheight}px);
        top: ${p => p.pagehight}px;
    }
`;

const LogoItem = styled(Menu.Item)`
    && {
        margin-top: auto;
    }
`;

const Star = styled.div`
    font-size: 2.6rem;
    font-weight: bold;
    line-height: 2.6rem;
    color: ${p => p.theme.color.black};
`;

const Base = styled.div`
    font-size: 1rem;
    line-height: 1rem;
    color: ${p => p.theme.color.black};
`;

const Logo = styled.img.attrs({
    src: logoSVG,
    alt: 'Starkiller base logo',
    className: 'ui',
})`
    height: 110px;
    width: auto;
    margin-bottom: 1rem;
`;

const SidebarMenu = ({
    isRootPath,
    pageYOffset,
    navbarHeight,
    children,
    visible,
    onVisible,
}) => (
    <Sidebar
        as={StyledMenu}
        vertical
        animation="push"
        visible={visible}
        size="large"
        navbarheight={navbarHeight}
        pagehight={pageYOffset}
        onVisible={onVisible}
    >
        { children }

        { !isRootPath && (
            <LogoItem as={Link} to="/" >
                <Logo />
                <Star>STARKILLER</Star>
                <Base>BASE</Base>
            </LogoItem>
        ) }
    </Sidebar>
);


SidebarMenu.propTypes = {
    isRootPath: bool.isRequired,
    children: element.isRequired,
    navbarHeight: number.isRequired,
    pageYOffset: number.isRequired,
    visible: bool.isRequired,
    onVisible: func.isRequired,
};

export default SidebarMenu;
